import Vue from "vue";
import FormGroup from "./FormGroup.vue";

Vue.component("FormGroup", FormGroup);
